import { methods, request } from "./base";
import {
  OrderHistoryRequestPayload,
  OrderHistoryResponse,
} from "src/types/orderHistory.types";

const orderHistoryApis = {
  getOrderHistory: async (data: OrderHistoryRequestPayload) =>
    await request({
      method: methods.POST,
      route: "/tests/order_history",
      payload: data,
    }),
};

export default orderHistoryApis;
